export default __webpack_public_path__ + "static/media/hackerrank.4ae1e1ac.png";